/**
 * Single Public Entry für den Marketing-/Tracking-Layer der Landing-Pages.
 *
 * DSGVO-konform: Pixel laden erst nach Opt-in (ConsentBanner). Event-Tracking
 * ist ohne Consent ein No-op. Pixel-IDs ausschließlich über NEXT_PUBLIC_*-
 * Env-Vars (siehe analytics.ts).
 */

export { ConsentBanner } from './ConsentBanner';
export { useScrollDepth } from './useScrollDepth';
export { trackEvent, getConsent, setConsent, initPixels } from './analytics';
export type { MarketingEvent, ConsentState } from './analytics';
